/**
 * Footer Component
 * Bottom footer section
 */

import React from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        mt: 6,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: (theme) =>
          theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2}>
          <Stack direction="row" spacing={3} sx={{ flexWrap: 'wrap' }}>
            <Link
              href="https://github.com/aminfathullah/netra"
              target="_blank"
              rel="noopener"
              sx={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
            >
              <Typography variant="body2" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                GitHub
              </Typography>
            </Link>
            <Link
              href="https://github.com/aminfathullah/netra/docs"
              target="_blank"
              rel="noopener"
              sx={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
            >
              <Typography variant="body2" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                Docs
              </Typography>
            </Link>
            <Link
              href="https://github.com/aminfathullah/netra/issues"
              target="_blank"
              rel="noopener"
              sx={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
            >
              <Typography variant="body2" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                Issues
              </Typography>
            </Link>
          </Stack>

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            © {currentYear} Netra. Zero-server uptime monitoring powered by Git.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
